import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import * as dayjs from "dayjs";
@Component({
  selector: "app-drug-distribution-data-revision-dropdown",
  templateUrl: "./drug-distribution-data-revision-dropdown.component.html",
  styleUrls: ["./drug-distribution-data-revision-dropdown.component.scss"],
})
export class DrugDistributionDataRevisionDropdownComponent implements OnInit {
  checkOptions = [
    { label: "Values", value: "values", checked: false },
    { label: "YoY%", value: "yoy", checked: false },
  ];
  radioValue = "";
  inValidCustomDate = false;
  customDate = null;
  dvErrMsg = "";
  invalidDataview: boolean;
  selectedDataView: string;
  dataViewFilterVisible: boolean;
  dataviewApplied: boolean;
  popoverOpen = false;
  viewBy: string;
  @Input() singleSelect: boolean;
  @Input() dataView;
  @Output() saveDataView = new EventEmitter();
  constructor() {
    this.dataView = {};
  }

  ngOnInit() {
    this.checkOptions = [
      { label: "Values", value: "values", checked: false },
      { label: "YoY%", value: "yoy", checked: false },
    ];
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.dataView && changes.dataView.currentValue) {
      this.dataView = changes.dataView.currentValue;
      this.viewBy = this.dataView.view_by[0] || "";
      if (this.dataView && this.dataView["view_by"][0] !== "revision") {
        this.radioValue = "";
        for (let i = 0; i < 2; i++) {
          this.checkOptions[i].checked = this.dataView["view_by"].includes(
            this.checkOptions[i].value,
          )
            ? true
            : false;
        }
        if (this.dataView["view_by"].length < 2) {
          this.selectedDataView =
            this.dataView["view_by"][0] === "values" ? "Values" : "YoY%";
        } else {
          this.selectedDataView = "Values,YoY%";
        }
      } else if (this.dataView["revision"]) {
        if (this.dataView["revision"].startsWith("custom")) {
          this.radioValue = "custom";
          this.customDate = this.dataView["revision"].split("|")[1];
          this.selectedDataView = this.customDate;
        } else {
          this.radioValue = this.dataView["revision"];
          this.selectedDataView =
            this.dataView["revision"][0] === "1"
              ? ` ${this.dataView["revision"][0]} month`
              : ` ${this.dataView["revision"][0]} months`;
        }
      }
    }
  }
  radioValChange() {
    this.checkOptions.map((option) => {
      option.checked = false;
      return { ...option };
    });
    this.viewBy = "revision";
  }

  chkboxOptChange() {
    this.radioValue = "";
    if (this.singleSelect) {
      this.checkOptions.map((option) => {
        option.checked = option.value === this.viewBy;
        return { ...option };
      });
    }
  }
  onDateChange() {
    if (this.customDate !== null) {
      this.inValidCustomDate = false;
    }
    this.radioValue = "custom";
    this.viewBy = "";
  }
  applyDataView() {
    let viewBy = [];
    if (
      !this.radioValue &&
      !this.checkOptions[0].checked &&
      !this.checkOptions[1].checked
    ) {
      this.invalidDataview = true;
      // this.dv  = "Please select a value";
    } else {
      this.invalidDataview = false;
      this.dvErrMsg = "";
      if (this.radioValue !== "") {
        let revision = "";
        let dateStr = "";
        viewBy = ["revision"];
        switch (this.radioValue) {
          case "1m":
            this.inValidCustomDate = false;
            this.selectedDataView = " 1 month";
            dateStr = dayjs().subtract(30, "day").format("MM-DD-YYYY");
            revision = `1m`;
            break;
          case "3m":
            this.inValidCustomDate = false;
            this.selectedDataView = " 3 months";
            dateStr = dayjs().subtract(90, "day").format("MM-DD-YYYY");
            revision = `3m`;
            break;
          case "custom":
            if (this.customDate === null) this.inValidCustomDate = true;
            else {
              this.inValidCustomDate = false;
              dateStr = dayjs(this.customDate).format("MM-DD-YYYY");
              this.selectedDataView = dateStr;
              revision = `custom|${dateStr}`;
            }
            break;
          default:
            break;
        }
        this.setDataView(revision, viewBy);
      } else {
        this.inValidCustomDate = false;
        //console.log(this.checkOptions);
        if (this.checkOptions[0].checked && this.checkOptions[1].checked) {
          this.selectedDataView = "Values,YoY%";
          this.setDataView("", ["values", "yoy"]);
        } else {
          if (this.checkOptions[0].checked) {
            this.selectedDataView = this.checkOptions[0].label;
            this.setDataView("", ["values"]);
          }
          if (this.checkOptions[1].checked) {
            this.selectedDataView = this.checkOptions[1].label;
            this.setDataView("", ["yoy"]);
          }
        }
      }
    }

    //this.inValidCustomDate
  }
  setDataView(revision, viewBy) {
    if (!this.inValidCustomDate) {
      this.dataViewFilterVisible = false;
      this.dataviewApplied = true;
      this.saveDataView.emit({ viewBy, revision });
    }
  }

  disabledCustomDate = (customValue: Date): boolean => {
    return customValue >= dayjs().toDate();
  };
  popoverChange() {
    this.popoverOpen = !this.popoverOpen;
    if (this.popoverOpen) {
      this.dataviewApplied = false;
    }
    if (!this.popoverOpen && !this.dataviewApplied) {
      this.onResetDataView();
    }
  }

  onResetDataView() {
    this.dataViewFilterVisible = false;
    if (this.dataView && this.dataView["view_by"][0] !== "revision") {
      this.radioValue = "";
      for (let i = 0; i < 2; i++) {
        this.checkOptions[i].checked = this.dataView["view_by"].includes(
          this.checkOptions[i].value,
        )
          ? true
          : false;
      }
      if (this.dataView["view_by"].length < 2) {
        this.selectedDataView =
          this.dataView["view_by"][0] === "values" ? "Values" : "YoY%";
      } else {
        this.selectedDataView = "Values,YoY%";
      }
    } else {
      for (let i = 0; i < 2; i++) {
        this.checkOptions[i].checked = false;
      }
      if (this.dataView["revision"].startsWith("custom")) {
        this.radioValue = "custom";
        this.customDate = this.dataView["revision"].split("|")[1];
      } else {
        this.radioValue = this.dataView["revision"];
      }
    }
    this.viewBy = this.dataView.view_by[0] || "";
  }
}
